module.exports = __webpack_public_path__ + "media/images/black_history_month/bg-shape-lemon-d1f1772c4da4ddd8944bcc59f32134ad.svg";